import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { baseText } from "../Lang/fa/BaseText";
import { NavLinks } from "./NavLinks";
import { Lang } from "../Lang/MainLang";

const StyleNave = styled.div`
    direction: ${Lang.direction};
    z-index: 890;
    position: fixed;
    height: 0;
    inset: 0 0 0 auto;
    width: 100%;
    --menu-bg-blur: var(--body-2);
    --menu-text:var(--text-2);
    --menu-arr: #484849;
    &.dark-nav{
        --menu-bg-blur: var(--nav-main-bg);
        --menu-text: var(--nav-text-1);
        --menu-arr: var(--text-3)
    }
    .backdrop {
        z-index: 999;
        position: fixed;
        display: none;
        top: var(--top-gap);
        right: var(--padding);
        width: calc(100vw - 2rem - var(--padding) * 2);
        min-height: 310px;
        padding: 1.5rem 1rem 1.5rem;
        background: var(--menu-bg-blur);
        backdrop-filter: blur(15px);
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
        border-radius: 8px 0px 8px 8px;
        .item {
            text-decoration: none;
            cursor: default;
            display: flex;
            color: var(--menu-text);
            font-weight: 400;
            white-space: nowrap;
            transition: all 0.1s ease-in-out;
            .name-g1 {
                flex-grow: 1;
                padding: 0.7rem 2rem 0.7rem;
                text-decoration: none;
                color: var(--menu-text);
            }
            .name-g2 {
                flex-grow: 1;
                padding: 0.7rem 2rem 0.7rem;
                text-decoration: none;
                color: var(--menu-text);
            }
            .name-g3 {
                flex-grow: 1;
                padding: 0.7rem 2rem 0.7rem;
                text-decoration: none;
                color: var(--menu-text);
            }
            .expand {
                flex-grow: 1;
                text-decoration: none;
            }
            &.all {
                padding: 0.7rem 2rem 0.7rem;
                :hover {
                    .name {
                        color: var(--primary-5);
                    }
                }
            }
            /* :hover {
                font-weight: 800;
                color: var(--primary-1);
                fill: var(--primary-1);
                .icon{
                    .group-arrow {
                        fill: var(--primary-1);
                    }
                }
                
                .name-g2{
                    color: var(--primary-1);
                }
                .name-g3{
                    color: var(--primary-1);
                }
            } */
            .dot-icon {
                position: relative;
                top: -0.15rem;
                color: var(--primary-1);
                padding: 0 0.3rem;
                width: 0.8rem;
            }
            .icon {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-right: 10px;
                .group-arrow {
                    width: 14px;
                    height: 14px;
                    fill:var(--menu-arr);
                }
            }
        }
        &.active {
            display: flex;
        }
        .groups {
            position: relative;
            min-width: 17rem;
            ${Lang.direction === "rtl" ? "border-left: 2px solid var(--nav-border);" : "border-right: 2px solid var(--nav-border);"} 
            .group {
                cursor: pointer;
                :hover {
                    font-weight: 600;
                    background-color: #2035691A;
                    .icon{
                        .group-arrow {
                            fill: var(--primary-5);
                        }
                    }
                    .name-g1{
                        color: var(--primary-5);
                    }
                    .tags {
                        display: flex;
                    }
                }
                .tags {
                    min-width: 17rem;
                    position: absolute;
                    display: none;
                    flex-direction: column;
                    top: 0;
                    ${Lang.direction === "rtl" ? "right: 100%;" : "left: 100%;"} 
                    min-height: 100%;
                    max-height: 100%;
                    ${Lang.direction === "rtl" ? "border-left: 2px solid var(--nav-border);" : "border-right: 2px solid var(--nav-border);"} 
                    .tag {
                        display: flex;
                        :hover {
                            font-weight: 600;
                            background-color: #2035691A;
                            .icon{
                                .group-arrow {
                                    fill: var(--primary-5);
                                }
                            }
                            .name-g2{
                                color: var(--primary-5);
                            }
                            .subs {
                                display: flex;
                            }
                        }
                        .icon {
                            .tag-arrow {
                                width: 14px;
                                height: 14px;
                                fill:var(--menu-arr);
                            }
                            :hover{
                                fill: var(--primary-1);
                            }
                        }
                        .subs {
                            padding: 2.8rem 0 0 0;
                            display: none;
                            flex-direction: column;
                            position: absolute;
                            top: 0;
                            ${Lang.direction === "rtl" ? "right: 100%;" : "left: 100%;"} 
                            height: calc(100% - 2.5rem);
                            flex-wrap: wrap;
                            .item{
                               cursor: pointer;
                            }
                            .sub {
                                :hover {
                                    font-weight: 600;
                                    .icon{
                                        .group-arrow {
                                            fill: var(--primary-5);
                                        }
                                    }
                                    .name-g3{
                                        color: var(--primary-5);
                                    }
                                }
                            }
                        }
                        
                    }
                    .item{
                        :first-child{
                            cursor: pointer;
                        }
                    }
                }
                
            }
            
        }
    }
    .top-nav-shop{
        z-index: 899;
        position: fixed;
        inset: 60px 0 0 0;
        padding: 0 var(--padding);
        width: calc(100% - var(--width-padding)) ;
        height: 50px;
        display: grid;
        grid-template-columns: 15% 70% 15%;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: var(--nav-main-bg-blur);
        backdrop-filter: blur(15px);
        transition:  all 0.2s ease-out;
        border-top: 1px solid var(--nav-border);
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
        &.hide{
            transition:  all 0.3s ease-out;
            top: -20px;
            height: 0;
         }
        .drawre-second{
            z-index: 3;
            display: flex;
            flex-grow: 1;
            flex-direction: row;
            align-items: center;
            height: 100%;
            cursor: pointer;
            position: relative;
            .ham {
                transform: scale(-1, 1);
                fill:var(--nav-text-1);
                width: 1.5rem !important;
            }
            span{
                color: var(--nav-text-1);
                font-weight: 500;
                font-size: var(--fs-nav-second);
                margin-right: 0.5rem;
                white-space: nowrap;

            }
            
        }       
    }
   
    @media screen and (max-width :850px) {
       
        .mobile-nav2{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width:calc(100% - var(--width-padding)) ;
            padding:0 var(--padding) ;
            
            .search{
                width: calc(100% - 59px);
                height: 30px;
                top: 0;
                right: 0;
                position: relative;
                &.mobile-nav-home2{
                    width: 100%;
                }
                .icon{
                    width: 20px;
                    height: 20px;
                    top: 0.2rem;
                    margin-left: 0.8rem;
                }
                .input{
                    padding: 0;
                    width: calc(100% - 32px);
                }
            }
            .nav-link {
                cursor: pointer;
                position: relative;
                padding: 0;
                margin: 0;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 1.2em;
                color: var(--primary-1);
                /* transition: all 0.3s ease-in-out; */
                .nav-icon {
                    width: 28px;
                    fill: var(--primary-1);
                    border: 1px solid var(--nav-border);
                    background: none;
                    border-radius: var(--border-radius-2);
                    padding: 6px 8px;
                }
                
                .small-number {
                    color: var(--text-3);
                    cursor: pointer;
                    position: absolute;
                    text-align: center;
                    min-width: 0.4rem;
                    padding: 0.1rem 0.25rem 0rem;
                    border-radius: 10rem;
                    font-size: 0.6rem;
                    font-weight: 800;
                    top: 28px;
                    right: calc(50% - 0.47rem);
                    background-color: var(--secondry-1);
                }
            }
        }
        .hide-nav{
            display: none;
        }
    }
`

class SecondNavbar extends React.Component{
    constructor(props){
        super(props);
        this.state={
            hide:false,
            scroll: 0,
            path : this.props.location.pathname.split('/')[1],
            hoverMenu: false,
        }
    }
    componentDidMount() {
        window.addEventListener("scroll", this.hideNav);
        document.addEventListener('mousemove' , this.changeHover ,{passive:false})
    }
      
    componentWillUnmount() {
        window.removeEventListener("scroll", this.hideNav);
        document.removeEventListener('mousemove' , this.changeHover)
    }
    getSnapshotBeforeUpdate(prevProps, prevState){
        if(this.props.location.pathname.split('/')[1] !== prevProps.location.pathname.split('/')[1]){
            return true
        }
        return false
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(snapshot){
            this.setState({
                path: this.props.location.pathname.split('/')[1]
            })
        }
    }
    clickCat=(e)=>{
        var pathFind = e.path || (e.composedPath && e.composedPath());
        if(!pathFind){
            this.setState({
                hoverMenu : true
            })
        }
    }
    changeHover = (e) => {
        var pathFind = e.path || (e.composedPath && e.composedPath());
        if(pathFind){
            let path = e.path ;
            if(path === undefined){
               path = e.composedPath()
            }
            let find = false
            for( let i = 0 ; i < path.length ; i++ ){
                let value = path[i]
                if(value.id === 'main-menu'){
                    find = true
                }
            }
            if(this.state.hoverMenu !== find) {
                if(find){
                    document.getElementsByTagName("BODY")[0].style.overflow = 'hidden';
                } else {
                    document.getElementsByTagName("BODY")[0].style.overflow = 'auto';
                }
                this.setState({
                    hoverMenu: find
                })
            }
        }
    }

    hideNav=(e)=>{
        if(this.state.hoverMenu){
            e.preventDefault();
            return false
        }
        if(!this.props.showFilter){
            const currnetY = window.pageYOffset
            if(((currnetY - this.state.scroll) < -20 && currnetY < this.state.scroll ) || currnetY < 50){
                this.setState({
                    hide:false,
                    scroll: currnetY,
                })
            }
            if(currnetY > this.state.scroll && currnetY > 50){
                this.setState({
                    scroll: currnetY,
                    hide: true
                })
            }
        }else{
            this.setState({
                hide:false
            })
        }
    }
    toggleDrawer = (val) => {
        if(!val){
            document.getElementsByTagName("BODY")[0].style.overflow = 'auto';
        }
        this.setState({
            hoverMenu: val
        })
    }
   

    arrow = (name) => {
        return <svg className={name + "-arrow"} style={{transform: "rotate(180deg)"}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 150 150"><title>arrows-footer</title><path className="st0" d="M37.5,8.1c0,1.9,0.8,3.7,2.2,5.1l55.2,52.1c4.7,4.4,4.9,11.8,0.5,16.4l-52.1,55.2c-2.8,2.7-2.9,7.1-0.2,9.9 c2.7,2.8,7.1,2.9,9.9,0.2c0.2-0.1,0.3-0.3,0.4-0.5l52.1-55.2c4.7-4.9,7.2-11.5,7-18.3c-0.2-6.8-3.1-13.2-8-17.9L49.3,3 c-2.8-2.6-7.2-2.5-9.9,0.3C38.2,4.6,37.5,6.3,37.5,8.1z"></path></svg>
    }

    // make subgroup list
    makeSubGroups = (subs, G_GR_EN_NAME) => {
        let newsubs = []
        newsubs = subs.map((value, index) => {
        return (
            <Link
            key={index}
            to={"/category/" + value.G_SUBGR_EN_NAME+'/'}
            className="sub item"
            onClick={() => this.toggleDrawer(false)}
            >
            <div className="name-g3">- {value.G_SUBGR_NAME}</div>
            </Link>
        )
        });
        return newsubs
    }

    makeTags = (tags, G_GR_EN_NAME,G_GR_CODE) => {
        let newtags = [];
        newtags = tags.map((value, index) => {
            return (
                <div
                    key={index}
                    className={"tag item"}
                >
                    <Link to={"/category/" + value.G_TAG_EN_NAME+'/'} className="name-g2">{value.G_TAG_NAME}</Link>
                    {/* <Link to={"/search/" + value.G_TAG_EN_NAME} className="expand"></Link> */}
                    {/* <div className="icon">
                        {this.arrow('tag')}
                    </div> */}
                    <div className="subs" style={{minWidth: ((value.SUB_GROUP.length > ((tags.length > 6) ? tags.length : 6) ) ? 'calc(50vw - 3rem)' : 'calc(20vw - 3rem)')}}>
                        {this.makeSubGroups(value.SUB_GROUP, G_GR_CODE)}
                    </div>
                </div>
            )
        })
        newtags.splice(0, 0, (
        <Link
            key={-1}
            to={"/category/" + G_GR_EN_NAME+'/'}
            className={"all item" + ((this.props.location.pathname === "/category/" + G_GR_EN_NAME) ? ' active' : '')}
            onClick={() => this.toggleDrawer(false)}
        >
            <div className="name" style={{fontWeight: 800 , textDecoration:'none'}}>{baseText.all}</div>
        </Link>
        ))
        return newtags
    }

    // make groups list
    makeGroups = () => {
        return this.props.menus.map((value, index) => {
            return (
                <React.Fragment key={index}>
                    <div
                        key={index}
                        className={"group item "}
                        // onClick={() => this.openGroupClick(index)}
                    >
                        <Link
                            to={"/category/" + value.G_GR_EN_NAME+'/'} className="name-g1"
                        >
                            {value.G_GR_NAME}
                        </Link>
                        {/* <Link
                            to={"/search/" + value.G_GR_EN_NAME} className="expand"
                        ></Link> */}
                        {/* <div className="icon">
                            {this.arrow('group')}
                        </div> */}
                        <div className={"tags"}>
                            {this.makeTags(value.TAG, value.G_GR_EN_NAME ,value.G_GR_CODE)}
                        </div> 
                    </div>
                </React.Fragment>
            )
        })
    }
    renderMobile=(home ,tagMax)=>{
        let classHide = ''
        if(window.location.pathname.split('/')[1] === 'campaign'){
            let searchHide = new URLSearchParams(document.location.search).get('page')
            if(parseInt(searchHide) < 5 || searchHide === null){
                classHide = 'hide-nav'
            }
        }
        return(
            <React.Fragment>
                <div className={'top-nav-shop mobile-nav2 ' + (this.state.hide ? ' hide ' : '') + classHide}
                >
                    {this.props.getSearch()}
                    {/* {!this.props.home2 ? ''  : this.props.basketShow()} */}
                    {this.props.basketShow()}
                </div>
            </React.Fragment>
        )
    }
    renderLaptop=(home ,tagMax)=>{
        return(
            <React.Fragment>
               <div className={'top-nav-shop' + (this.state.hide ? ' hide' : '')}
                >
                    <div 
                        className={"drawre-second" + ((this.state.hoverMenu) ? " active" : '')} 
                        style={{ flexGrow: 1 }}
                        id="main-menu"
                        onClick={this.clickCat}
                    >
                        {/* <UniDrawer {...this.props}/> */}
                        <svg viewBox="0 0 24 24" className="ham" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z" />
                        </svg>
                        <span>{baseText.allCategories}</span>
                    </div>
                    <NavLinks/>
                 </div>
                 <div 
                    className={"backdrop " + ((this.state.hoverMenu) ? " active" : '') } 
                    id="main-menu"
                    style={{minHeight: (tagMax * 45) + "px"}}
                >
                    <div className="groups">
                        {this.makeGroups()}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render(){
        let home = (this.props.location.pathname === '/')
        let tagMax = this.props.menus.length;
        this.props.menus.forEach((v) => {
            if(tagMax < v.TAG.length + 1){
                tagMax = v.TAG.length + 1
            }
        })
        return(
            <StyleNave className={home ? 'dark-nav' : ''}>
                {
                    window.innerWidth > 850 ?(
                        this.renderLaptop(home ,tagMax)
                    ):
                        this.renderMobile(home ,tagMax)
                }
    
            </StyleNave>
        )
    }
}

export default SecondNavbar